import React, { FC } from 'react';
import { useTranslations } from 'next-intl';
import FulfillmentPopup from '@/libs/fulfillmentPopup/fulfillmentPopup';
import { pushGTMClickTags } from '@/libs/pushGTMTags/pushGTMTags';
export interface DownloadButtonProps {
  downloadReady: boolean;
  docData?: {
    docUrl?: string;
  };
}
const DownloadButton: FC<DownloadButtonProps> = ({
  downloadReady,
  docData
}) => {
  const t = useTranslations('Asset');
  return <>
   {downloadReady && docData?.docUrl && <div className="download-section">
     <button type="button" className="tt-button-lrg" onClick={() => {
        FulfillmentPopup(docData?.docUrl);
        pushGTMClickTags({
          click_element: 'Button',
          click_closest_class: 'NONE',
          click_section_ID: 'NONE',
          link_classes: 'tt-button-lrg',
          link_id: 'NONE',
          link_text: 'Download',
          link_url: docData?.docUrl,
          click_category: 'NONE',
          click_destination: 'popup',
          click_closest_href: 'NONE'
        });
      }}>
      {t('Download')}
     </button>
    </div>}
  </>;
};
export default DownloadButton;